import {Col, Container, Row} from "react-bootstrap";
import React from "react";
export default function CompleteButton(props) {
    return (<>
        <Container fluid className={props.isActionColBtn?"d-none":"m-0 p-0"}>
            <a href="#" onClick={props.onCompleteClick}>
                <span className='d-md-block'>{props.buttonTitle}</span>
            </a>
        </Container>
        <Container fluid className={!props.isActionColBtn?"d-none":"m-0 p-0"}>
            <button className="btn btn-block td-btn-primary-light my-3" href="#" onClick={props.onCompleteClick}>
                {props.buttonTitle??'Complete'}
            </button>
        </Container>
    </>)
}